import React, { useState } from "react";
import { useNavigate } from "react-router";
import { MessageCircle, Type, ChevronRight, Shield, FileText } from "lucide-react";
import { useAdminAuth, getRoleLabel } from "../auth/AdminAuthContext";
import { LegalDocumentsList } from "../../components/LegalDocumentsList";

export function AdminSettingsPage() {
  const navigate = useNavigate();
  const { user } = useAdminAuth();
  const [docsOpen, setDocsOpen] = useState(true);

  const links = [
    {
      href: "/ui-strings",
      title: "Системные тексты",
      desc: "Подписи и строки интерфейса PWA / админки",
      icon: <Type size={18} className="text-indigo-500" />,
      roles: ["super_admin"] as const,
    },
    {
      href: "/support-bot",
      title: "Чат-бот поддержки",
      desc: "Глобальные настройки бота MAX",
      icon: <MessageCircle size={18} className="text-violet-500" />,
      roles: ["super_admin"] as const,
    },
  ].filter((l) => user?.role && (l.roles as readonly string[]).includes(user.role));

  return (
    <div className="p-4 sm:p-6 max-w-lg mx-auto space-y-4">
      <div>
        <h1 className="text-[19px] text-gray-900">Настройки</h1>
        <p className="text-[13px] text-gray-400 mt-0.5">MVK One · служебные разделы</p>
      </div>

      {user && (
        <div className="bg-white rounded-xl border border-gray-100 p-4 flex items-start gap-3">
          <div className="w-9 h-9 rounded-lg bg-indigo-50 flex items-center justify-center flex-shrink-0">
            <Shield size={16} className="text-indigo-500" />
          </div>
          <div className="min-w-0">
            <div className="text-[14px] text-gray-900 truncate">{user.name || user.email}</div>
            <div className="text-[12px] text-gray-400 mt-0.5">
              {getRoleLabel(user.role)}
              {user.email ? ` · ${user.email}` : ""}
            </div>
          </div>
        </div>
      )}

      <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">
        <button
          type="button"
          onClick={() => setDocsOpen((v) => !v)}
          className="w-full flex items-center gap-3 px-4 py-3.5 text-left hover:bg-gray-50"
        >
          <div className="w-9 h-9 rounded-lg bg-slate-50 flex items-center justify-center flex-shrink-0">
            <FileText size={18} className="text-slate-600" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-[14px] text-gray-900">Документы</div>
            <div className="text-[12px] text-gray-400 mt-0.5">
              Пользовательское соглашение, политика и согласие на ПДн
            </div>
          </div>
          <ChevronRight
            size={16}
            className={`text-gray-300 flex-shrink-0 transition-transform ${docsOpen ? "rotate-90" : ""}`}
          />
        </button>
        {docsOpen ? (
          <div className="px-4 pb-4 border-t border-gray-50 pt-3">
            <LegalDocumentsList />
          </div>
        ) : null}
      </div>

      <div className="bg-white rounded-xl border border-gray-100 divide-y divide-gray-50">
        {links.length === 0 ? (
          <p className="p-4 text-[13px] text-gray-500">Нет доступных разделов для вашей роли.</p>
        ) : (
          links.map((l) => (
            <button
              key={l.href}
              type="button"
              onClick={() => navigate(l.href)}
              className="w-full flex items-center gap-3 px-4 py-3.5 text-left hover:bg-gray-50"
            >
              <div className="w-9 h-9 rounded-lg bg-gray-50 flex items-center justify-center flex-shrink-0">
                {l.icon}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-[14px] text-gray-900">{l.title}</div>
                <div className="text-[12px] text-gray-400 mt-0.5">{l.desc}</div>
              </div>
              <ChevronRight size={16} className="text-gray-300 flex-shrink-0" />
            </button>
          ))
        )}
      </div>
    </div>
  );
}
